import { isMeetingCancelled, isMeetingPending } from 'common-data-handling';
import React, { useCallback } from 'react';
import { useParams } from 'react-router-dom';
import meetingState from '../../../data/constants/meetingState';
import { getMeetingURL } from '../Meeting/getMeetingURL';
import styles from './MeetingStateIcon.module.scss';
import CancelledIcon from './res/meeting-cancelled.svg';
import ConfirmedIcon from './res/meeting-confirmed.svg';
import PendingIcon from './res/meeting-pending.svg';
import ReplyIcon from './res/reply-solid.svg';

// TODO: remove need to receive invite as props
// TODO: remove usage of _state and _myInvite

export default function MeetingStateIcon(props) {
    const { className = '', event, meeting, invite, allowStateChange } = props,
        classes = [className, styles.MeetingStateIcon],
        { meetingTab } = useParams(),
        href = getMeetingURL(event.id, meeting.id, meetingTab);

    const handleOpenMeeting = useCallback(() => {
        app.history.push(href);
    }, [href]);

    if (invite) {
        if (meeting._state != meetingState.CANCELLED && allowStateChange && invite == meeting._myInvite && invite.state == 0) {
            return (
                <button className={[className, styles.reply].join(' ')} onClick={handleOpenMeeting}>
                    <ReplyIcon />
                </button>
            );
        }
    }

    if (isMeetingPending(meeting)) {
        classes.push(styles.pending);
        return <PendingIcon className={classes.join(' ')} />;
    } else if (isMeetingCancelled(meeting)) {
        classes.push(styles.cancelled);
        return <CancelledIcon className={classes.join(' ')} />;
    } else {
        classes.push(styles.confirmed);
        return <ConfirmedIcon className={classes.join(' ')} />;
    }

    return null;
}
